module.exports = __webpack_public_path__ + "media/images/emblems/Rebstein_wappen-79dbb52cef78eb81a35a1b001853dc9c.png";